
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "class": "icon",
    "width": "200px",
    "height": "200.00px",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M926 527.563c17.384 0 31.476-14.092 31.476-31.476S943.384 464.612 926 464.612H544v-73.543h118c17.673 0 32-14.327 32-32V129.99c0-17.673-14.327-32-32-32H362c-17.673 0-32 14.327-32 32v229.078c0 17.673 14.327 32 32 32h118v73.543H98c-17.384 0-31.476 14.092-31.476 31.476S80.616 527.563 98 527.563h143.604v72.783h-118c-17.673 0-32 14.327-32 32v229.078c0 17.673 14.327 32 32 32h300c17.673 0 32-14.327 32-32V632.347c0-17.673-14.327-32-32-32h-118v-72.783h412.228v72.783h-122.61c-17.673 0-32 14.327-32 32v229.078c0 17.673 14.327 32 32 32h300c17.673 0 32-14.327 32-32V632.347c0-17.673-14.327-32-32-32h-113.39v-72.783H926zM394 161.99h236v165.078H394V161.99z m-2.396 667.435h-236V664.347h236v165.078z m471.618 0h-236V664.347h236v165.078z",
        "fill": "#ffffff"
      }
    }
  ]
})
    }
  